import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import CustomSelect2 from './CustomSelect2';
import { Box, Typography, FormControlLabel, Grid, Checkbox, TextField, InputAdornment, Select, MenuItem, colors, Snackbar, Button, Skeleton } from '@mui/material';
import SelectPlanCheckbox from './SelectPlanCheckbox';
import { ConfigContext } from '../utils/ConfigContext';
import TableRatesRow from './TableRatesRow';
import getSafe from '../utils/getSafe';
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { styled } from '@mui/material/styles';
import PercentInput from './PercentInput';
import NotesDisplay from './NotesDisplay';
import RatesVersionSelect from './RatesVersionSelect';
import CopyImageButton from './CopyImageButton';
import CopyExcelDataButton from './CopyExcelDataButton';



const ProMedico_Rates = forwardRef(({ appConfig, sx, clients, currency, _currency, selectedPlans,
  setSelectedPlans, loadingStatus, response, setResponse, deductibles, setDeductibles,
  addToPendingTasks, discounts, setDiscounts, loadings, setLoadings, computedRates,
  setComputedRates, specificAreaOfCoverage, setSpecificAreaOfCoverage, areaOfCoverage,
  setShowImageCopy, selectedOptions, addSelectedOption,
  setViewSelectedOption, specificCurrency, setSpecificCurrency,
  specificPaymentFrequency, setSpecificPaymentFrequency,
  proMedicoSpecific, setProMedicoSpecific , insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, handleFetchAppConfig, setShowRefreshNow }, ref) => {

  const id = 'pro_medico';

  // const { appConfig } = useContext(ConfigContext);

  const familyDiscounts = getSafe(() => appConfig.content.specifics.pro_medico.family_discounts);

  const [familyDiscount, setFamilyDiscount] = useState(getFamilyDiscountsLabel()[0]);

  function getFamilyDiscountsLabel() {
    const labels = [];

    for (let familyDiscount in familyDiscounts) {
      labels.push(familyDiscount);
    }

    return labels;
  }

  const containerRef = useRef(null);


  const specific_area_of_coverages = getSafe(() => appConfig.content.pro_medico_area_of_coverage);

  const currencies = ['SGD'];


  useEffect(() => {
    computedRates[id] = getComputedRatesForPlanComparison();
    setComputedRates(computedRates);
  }, [response, discounts, loadings, selectedPlans]);

  useEffect(() => {
    setTimeout(() => {
      addSelectedOption(id, 'family_discount', familyDiscount);
      addSelectedOption(id, 'specific_area_of_coverage', specificAreaOfCoverage[id]);
      addSelectedOption(id, 'specific_currency', specificCurrency[id]);
      addSelectedOption(id, 'specific_payment_frequency', specificPaymentFrequency[id]);
      addSelectedOption(id, 'deductible', deductibles[id]);
      addSelectedOption(id, 'discount', discounts[id] == '' ? 0 : discounts[id]);
      addSelectedOption(id, 'loading', loadings[id] == '' ? 0 : loadings[id]);
    }, 1000);
  }, [familyDiscount, specificAreaOfCoverage[id], specificCurrency[id], specificPaymentFrequency[id], deductibles[id], discounts[id], loadings[id]]);

  useEffect(() => {
    setViewSelectedOption(id, 'family_discount', (option_value) => {
      setFamilyDiscount(option_value);

      proMedicoSpecific['family_discount'] = option_value;
      setProMedicoSpecific({ ...proMedicoSpecific });
    });

    setViewSelectedOption(id, 'deductible', (option_value) => {
      deductibles[id] = option_value;
      setDeductibles(deductibles);
    });
    setViewSelectedOption(id, 'discount', (option_value) => {
      discounts[id] = option_value;
      setDiscounts(discounts);
    });

    setViewSelectedOption(id, 'loading', (option_value) => {
      loadings[id] = option_value;
      setDiscounts(loadings);
    });

    setViewSelectedOption(id, 'specific_area_of_coverage', (option_value) => {
      specificAreaOfCoverage[id] = option_value;
      setSpecificAreaOfCoverage(specificAreaOfCoverage);
    });

    setViewSelectedOption(id, 'specific_currency', (option_value) => {
      specificCurrency[id] = option_value;
      setSpecificCurrency(specificCurrency);
    });

    setViewSelectedOption(id, 'specific_payment_frequency', (option_value) => {
      specificPaymentFrequency[id] = option_value;
      setSpecificPaymentFrequency(specificPaymentFrequency);
    });
  }, [selectedOptions]);

  function getComputedRatesForPlanComparison() {
    if (!response) return;

    const rates = response.rates;
    const discount = parseFloat(discounts[id]) || 0;
    const loading = parseFloat(loadings[id]) || 0;
    const totalPercent = ((100 - discount + loading) * 0.01);


    const computedRates = [];



    for (let i = 0; i < rates.length; i++) {
      let premier = rates[i].premier * totalPercent;
      let premier_plus = rates[i].premier_plus * totalPercent;
      let prime = rates[i].prime * totalPercent;
      let prestige = rates[i].prestige * totalPercent;
      let prestige_plus = rates[i].prestige_plus * totalPercent;

      let outpatient_plan_1 = rates[i].outpatient_plan_1 * totalPercent;
      let outpatient_plan_2 = rates[i].outpatient_plan_2 * totalPercent;
      let dental_care_plan_1 = rates[i].dental_care_plan_1 * totalPercent;
      let dental_care_plan_2 = rates[i].dental_care_plan_2 * totalPercent;
      let maternity = rates[i].maternity * totalPercent;

      if (selectedPlans.includes('pro_medico_outpatient_plan_1') && !isNaN(outpatient_plan_1)) {
        premier += outpatient_plan_1;
        premier_plus += outpatient_plan_1;
        prime += outpatient_plan_1;
      }
      if (selectedPlans.includes('pro_medico_outpatient_plan_2') && !isNaN(outpatient_plan_2)) {
        prestige += outpatient_plan_2;
        prestige_plus += outpatient_plan_2;
      }
      if (selectedPlans.includes('pro_medico_dental_care_plan_1') && !isNaN(dental_care_plan_1)) {
        premier += dental_care_plan_1;
        premier_plus += dental_care_plan_1;
        prime += dental_care_plan_1;
      }
      if (selectedPlans.includes('pro_medico_dental_care_plan_2') && !isNaN(dental_care_plan_2)) {
        prestige += dental_care_plan_2;
        prestige_plus += dental_care_plan_2;
      }
      if (selectedPlans.includes('pro_medico_maternity') && !isNaN(maternity)) {
        premier += maternity;
        premier_plus += maternity;
        prime += maternity;
        prestige += maternity;
        prestige_plus += maternity;
      }

      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'premier': premier,
        'premier_plus': premier_plus,
        'prime': prime,
        'prestige': prestige,
        'prestige_plus': prestige_plus,
      })
    }

    return computedRates;
  }


  function getComputedRates() {
    if (!response) return;

    const rates = response.rates;
    const discount = parseFloat(discounts[id]) || 0;
    const loading = parseFloat(loadings[id]) || 0;
    const totalPercent = ((100 - discount + loading) * 0.01);


    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'premier': rates[i].premier * totalPercent,
        'premier_plus': rates[i].premier_plus * totalPercent,
        'prime': rates[i].prime * totalPercent,
        'prestige': rates[i].prestige * totalPercent,
        'prestige_plus': rates[i].prestige_plus * totalPercent,
        'outpatient_plan_1': rates[i].outpatient_plan_1 * totalPercent,
        'outpatient_plan_2': rates[i].outpatient_plan_2 * totalPercent,
        'dental_care_plan_1': rates[i].dental_care_plan_1 * totalPercent,
        'dental_care_plan_2': rates[i].dental_care_plan_2 * totalPercent,
        'maternity': rates[i].maternity * totalPercent
      })
    }

    return computedRates;
  }

  function computeTotalPremiumPerPlan(plan) {
    let total = 0;

    for (let i = 0; i < clients.length; i++) {
      const totalPerClient = computeTotalPremiumPerClient(i, plan);
      if (!isNaN(totalPerClient)) {
        total += totalPerClient;
      }
    }

    return total;
  }

  function computeTotalPremiumPerClient(clientIndex, plan) {
    const computedRates = getComputedRates();

    if (!computedRates) return 0;

    const rates = computedRates[clientIndex];

    if (!rates) return 0;

    let total = 0;


    if (selectedPlans.includes('pro_medico_' + plan) && !isNaN(rates[plan])) {
      total += rates[plan];
    }

    // if (selectedPlans.includes('pro_medico_premier_plus') && !isNaN(rates.premier_plus)) {
    //   total += rates.premier_plus;
    // }
    // if (selectedPlans.includes('pro_medico_prime') && !isNaN(rates.prime)) {
    //   total += rates.prime;
    // }
    // if (selectedPlans.includes('pro_medico_prestige') && !isNaN(rates.prestige)) {
    //   total += rates.prestige;
    // }
    // if (selectedPlans.includes('pro_medico_prestige_plus') && !isNaN(rates.prestige_plus)) {
    //   total += rates.prestige_plus;
    // }


    if (['premier', 'premier_plus', 'prime'].includes(plan)) {
      if (selectedPlans.includes('pro_medico_outpatient_plan_1') && !isNaN(rates.outpatient_plan_1)) {
        total += rates.outpatient_plan_1;
      }
    }

    if (['prestige', 'prestige_plus'].includes(plan)) {
      if (selectedPlans.includes('pro_medico_outpatient_plan_2') && !isNaN(rates.outpatient_plan_2)) {
        total += rates.outpatient_plan_2;
      }
    }


    if (['premier', 'premier_plus', 'prime'].includes(plan)) {
      if (selectedPlans.includes('pro_medico_dental_care_plan_1') && !isNaN(rates.dental_care_plan_1)) {
        total += rates.dental_care_plan_1;
      }
    }

    if (['prestige', 'prestige_plus'].includes(plan)) {
      if (selectedPlans.includes('pro_medico_dental_care_plan_2') && !isNaN(rates.dental_care_plan_2)) {
        total += rates.dental_care_plan_2;
      }
    }


    if (selectedPlans.includes('pro_medico_maternity') && !isNaN(rates.maternity)) {
      total += rates.maternity;
    }

    return total;
  }

  function formatRate(rate) {
    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span style={{ color: '#f44336' }}>{'Unavailable'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign() + rate.toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCurrencySign() {
    const currency = getCurrency();

    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    }

    return '';
  }

  function getCurrency() {
    const computedRates = getComputedRates();

    if (!computedRates) return '';

    if (computedRates.length === 0) { return '' }

    return computedRates[0].currency;
  }




  function handleDeductibleChange(e) {
    const _deductibles = JSON.parse(JSON.stringify(deductibles));

    _deductibles.pro_medico = e.target.value;

    setDeductibles(_deductibles);

    // clearResponse();

    addToPendingTasks([id]);
  }


  function scrollToView() {
    // setTimeout(() => {
    //   containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // }, 200);
  }


  function clearResponse() {
    setResponse(prev => {
      return { ...prev, [id]: null };
    });
  }

  function getPlanLabel(plan) {
    if (plan === 'premier') {
      return 'Premier';
    } else if (plan === 'premier_plus') {
      return 'Premier Plus';
    } else if (plan === 'prime') {
      return 'Prime';
    } else if (plan === 'prestige') {
      return 'Prestige';
    } else if (plan === 'prestige_plus') {
      return 'Prestige Plus';
    }

    return '';
  }

  function isPlan1Enable() {
    return selectedPlans.includes('pro_medico_premier') || selectedPlans.includes('pro_medico_premier_plus') || selectedPlans.includes('pro_medico_prime');
  }

  function isPlan2Enable() {
    return selectedPlans.includes('pro_medico_prestige') || selectedPlans.includes('pro_medico_prestige_plus');
  }


  return (
    <Box id={id} sx={sx}>
      <Paper sx={{ borderColor: '#e0e0e0', borderWidth: 2, pb: 2, scrollMarginTop: '200px' }} variant='outlined' ref={containerRef}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#ffcf02', px: 2, py: 1 }}>
          <div style={{
            color: '#1a1446',
            backgroundColor: '#ffcf02',
            padding: 6,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 18,
            lineHeight: 1.2,
            width: 100,
            height: 60,
          }}>Liberty proMedico</div>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img
              src={`${process.env.PUBLIC_URL}/images/Liberty Blue Logo.png`}
              alt="Liberty"
              style={{ height: 50, userSelect: 'none', WebkitUserDrag: 'none' }}
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
            />
          </Box>
        </Box>
        <Box sx={{ p: 2 }}>

          <Box sx={{ display: 'flex', gap: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Plan Type</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_premier' />} label="Premier" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_premier_plus' />} label="Premier Plus" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_prime' />} label="Prime" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_prestige' />} label="Prestige" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_prestige_plus' />} label="Prestige Plus" />

              <Typography sx={{ mt: 1 }} fontSize={15} fontWeight={600}>Outpatient Services</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_outpatient_plan_1' />} label="Plan 1" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_outpatient_plan_2' />} label="Plan 2" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Dental Care (Optional)</Typography>

              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_dental_care_plan_1' />} label="Plan 1" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_dental_care_plan_2' />} label="Plan 2" />


              <Typography sx={{ mt: 1 }} fontSize={15} fontWeight={600}>Maternity Care (Optional)</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" onChangeCb={scrollToView} selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='pro_medico_maternity' />} label="Maternity" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Family Discount</Typography>
                <CustomSelect2
                  dense
                  value={familyDiscount}
                  onChange={(e) => {
                    setFamilyDiscount(e.target.value);

                    proMedicoSpecific['family_discount'] = e.target.value;
                    setProMedicoSpecific(proMedicoSpecific);

                    addToPendingTasks([id]);
                  }}
                  items={getFamilyDiscountsLabel()}
                  disabled={loadingStatus['pro_medico']}
                  sx={{ minWidth: 170 }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Deductible Option</Typography>
                <CustomSelect2
                  dense
                  value={deductibles['pro_medico']}
                  onChange={handleDeductibleChange}
                  items={appConfig.content.deductibles.pro_medico[specificCurrency[id]]}
                  disabled={loadingStatus['pro_medico']}
                  sx={{ minWidth: 170 }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area Of Coverage</Typography>
                <Select
                  size='small'
                  value={specificAreaOfCoverage[id]}
                  onChange={(e) => {
                    specificAreaOfCoverage[id] = e.target.value;
                    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                    // clearResponse();

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                      <MenuItem key={area_of_coverage} value={area_of_coverage} sx={{ fontSize: 12 }}>{area_of_coverage}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Currency</Typography>
                <Select
                  size='small'
                  value={specificCurrency[id]}
                  onChange={(e) => {
                    specificCurrency[id] = e.target.value;
                    setSpecificCurrency({ ...specificCurrency });

                    // setDeductibles(prev => {
                    //   return {
                    //     ...prev,
                    //     [id]: getSafe(() => appConfig.content.deductibles.pro_medico[specificCurrency[id]][0])
                    //   };
                    // });


                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    currencies && currencies.map(currency => (
                      <MenuItem key={currency} value={currency} sx={{ fontSize: 12 }}>{currency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Payment Frequency</Typography>
                <Select
                  size='small'
                  value={specificPaymentFrequency[id]}
                  onChange={(e) => {
                    specificPaymentFrequency[id] = e.target.value;
                    setSpecificPaymentFrequency({ ...specificPaymentFrequency });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["Annually", "Semi Annually", "Quarterly", "Monthly"].map(payment_frequency => (
                      <MenuItem key={payment_frequency} value={payment_frequency} sx={{ fontSize: 12 }}>{payment_frequency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Discount</Typography>
                <PercentInput
                  value={discounts[id]}
                  onCommit={(value) => setDiscounts(prev => ({ ...prev, [id]: value }))}
                />
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Loading</Typography>
                <PercentInput
                  value={loadings[id]}
                  onCommit={(value) => setLoadings(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
            </Box>
          </Box>




          {/* <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <Button
              size='small'
              sx={{ mb: 1 }}
              onClick={() => {
                var node = document.getElementById('table-pro-medico-rates');

                node.style = 'width: auto;';

                domtoimage.toBlob(node).then(function (blob) {
                  // Create ClipboardItem with blob and its type, and add to an array
                  const data = [new ClipboardItem({ [blob.type]: blob })];
                  // Write the data to the clipboard
                  navigator.clipboard.write(data);

                  setShowImageCopy(true);

                  node.style = 'width: 100%;';
                })
                  .catch(function (error) {
                    console.error('oops, something went wrong!', error);
                    node.style = 'width: 100%;';
                  });
              }}
              endIcon={<ContentCopyIcon />}
            >Copy Image</Button>
          </div> */}

          <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end', width: '100%', marginBottom: 7 }}>
            <CopyExcelDataButton
              elementId='table-pro-medico-rates'
              style={{ marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyImageButton
              elementId='table-pro-medico-rates'
              setShowImageCopy={setShowImageCopy}
              style={{ fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
          </div>

          <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
            <Table id='table-pro-medico-rates' size='small' sx={{ background: '#fff', width: `calc(100% + ${clients.length > 5 ? clients.length - 5 : 0} * 75px)` }}>
              <TableHead>
                <TableRow style={{ background: '#ffcf02' }}>
                  <TableCell style={{ width: 260, fontWeight: 600, color: '#000' }}>Plan</TableCell>
                  {
                    clients.map((client, idx) => {
                      if (client.full_name.trim() === '') {
                        return <TableCell style={{ width: 200, fontWeight: 600, color: '#000' }} key={idx}>_</TableCell>
                      }

                      return <TableCell style={{ width: 200, fontWeight: 600, color: '#000' }} key={idx}><div>{client.full_name} ({client.age})</div><div>{client.country_of_residence}</div>  </TableCell>
                    })
                  }
                  <TableCell style={{ fontWeight: 600, color: '#000' }}>Subtotal</TableCell>
                </TableRow>


              </TableHead>
              <TableBody>
                <TableRow style={{ backgroundColor: '#ffffff' }}>
                  <TableCell colSpan={clients.length + 2} style={{ fontWeight: 600, background: '#99e5ea' }}>Basic Hospital & Surgical Coverage</TableCell>
                </TableRow>
                <TableRatesRow
                  planId='pro_medico_premier'
                  planName='premier'
                  planLabel='Premier'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_premier')}
                />
                <TableRatesRow
                  planId='pro_medico_premier_plus'
                  planName='premier_plus'
                  planLabel='Premier Plus'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_premier_plus')}
                />
                <TableRatesRow
                  planId='pro_medico_prime'
                  planName='prime'
                  planLabel='Prime'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_prime')}
                />
                <TableRatesRow
                  planId='pro_medico_prestige'
                  planName='prestige'
                  planLabel='Prestige'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_prestige')}
                />
                <TableRatesRow
                  planId='pro_medico_prestige_plus'
                  planName='prestige_plus'
                  planLabel='Prestige Plus'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_prestige_plus')}
                />

                <TableRow style={{ backgroundColor: '#ffffff' }}>
                  <TableCell colSpan={clients.length + 2} style={{ fontWeight: 600, background: '#99e5ea' }}>Outpatient Services - Ride to Basic Hospital & Surgical Coverage</TableCell>
                </TableRow>

                <TableRatesRow
                  planId='pro_medico_outpatient_plan_1'
                  planName='outpatient_plan_1'
                  planLabel='Plan 1'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_outpatient_plan_1')}
                />
                <TableRatesRow
                  planId='pro_medico_outpatient_plan_2'
                  planName='outpatient_plan_2'
                  planLabel='Plan 2'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_outpatient_plan_2')}
                />
                {
                  (selectedPlans.includes('pro_medico_dental_care_plan_1') || selectedPlans.includes('pro_medico_dental_care_plan_2')) &&
                  <TableRow style={{ backgroundColor: '#ffffff' }}>
                    <TableCell colSpan={clients.length + 2} style={{ fontWeight: 600, background: '#99e5ea' }}>Dental Care (Optional)</TableCell>
                  </TableRow>
                }
                <TableRatesRow
                  planId='pro_medico_dental_care_plan_1'
                  planName='dental_care_plan_1'
                  planLabel='Plan 1'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_dental_care_plan_1')}
                />
                <TableRatesRow
                  planId='pro_medico_dental_care_plan_2'
                  planName='dental_care_plan_2'
                  planLabel='Plan 2'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_dental_care_plan_2')}
                />
                {
                  (selectedPlans.includes('pro_medico_maternity')) &&
                  <TableRow style={{ backgroundColor: '#ffffff' }}>
                    <TableCell colSpan={clients.length + 2} style={{ fontWeight: 600, background: '#99e5ea' }}>Maternity Care (Optional)</TableCell>
                  </TableRow>
                }
                <TableRatesRow
                  planId='pro_medico_maternity'
                  planName='maternity'
                  planLabel='Maternity'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? response.rates : []}
                  currency={specificCurrency[id]}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('pro_medico_maternity')}
                />
                {
                  ['premier', 'premier_plus', 'prime', 'prestige', 'prestige_plus'].map((plan, idx) => {
                    return (
                      selectedPlans.includes('pro_medico_' + plan) &&
                      <TableRow key={plan} style={{ backgroundColor: '#ffffff' }}>
                        <TableCell style={{ border: '2px solid #fff', fontWeight: 600, background: '#1a1446', color: '#fff' }}>Total Premium ({getPlanLabel(plan)})</TableCell>
                        {
                          clients.map((client, idx) => {
                            return <TableCell style={{ border: '2px solid #fff', background: '#1a1446', color: '#fff' }} key={idx}> {loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeTotalPremiumPerClient(idx, plan))}</TableCell>
                          })
                        }
                        <TableCell style={{ border: '2px solid #fff', background: '#1a1446', color: '#fff' }}>{loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeTotalPremiumPerPlan(plan))}</TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>

          </TableContainer>

          <NotesDisplay appConfig={appConfig} insurerId={id} />

          <RatesVersionSelect
            insurer={id}
            label="Rates Version"
            insurerRates={insurerRates}
            selectedRatesVersion={selectedRatesVersion}
            setSelectedRatesVersion={setSelectedRatesVersion}
            disabled={loadingStatus[id]}
            handleFetchAppConfig={handleFetchAppConfig}
            onChange={() => setShowRefreshNow(true)}
          />
        </Box>


      </Paper>
    </Box>
  );
});

export default ProMedico_Rates;